export default "__VITE_ASSET__BrH9b0or__"